import maxrecfb from '../../../assets/logos/maxrec-fb.png';
import { contact, defaultDescription, defaultTitle, foundingDate, legalName, url } from '../../../data/config';
import React from 'react';
import Helmet from 'react-helmet';

export const SEO = ({ title = defaultTitle, description = defaultDescription, location = '' }) => {
  const structuredDataOrganization = `{ 
		"@context": "http://schema.org",
		"@type": "Organization",
		"legalName": "${legalName}",
		"url": "${url}",
		"foundingDate": "${foundingDate}",
		"founders": [{
			"@type": "Person",
			"name": "${legalName}"
		}],
		"contactPoint": [{
			"@type": "ContactPoint",
			"email": "${contact.email}",
			"telephone": "${contact.phone}",
		}],
  	}`;

  return (
    <Helmet>
      <meta name="description" content="Usługi Wideo i Foto" />
      <meta name="image" content={`${url}${maxrecfb}`} />
      <meta property="og:url" content={`${url}${location}`} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="MAXREC FILM STUDIO" />
      <meta property="og:description" content="Usługi Wideo i Foto" />
      <meta property="og:image" content={`${url}${maxrecfb}`} />
      <script type="application/ld+json">{structuredDataOrganization}</script>
      <title>{title}</title>
      <html lang="pl" dir="ltr" />
    </Helmet>
  );
};
